import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const UploadImage = styled("div")`
  height: 100px;
  width: 120px;
  backdrop-filter: blur(2px);
  border: ${(props) =>
    props.isTechnicalFeasibility ? "1px dashed black" : "1px dashed #dddddd"};
  background-color: rgba(255, 255, 255, 0.5);
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const DocumentName = styled(Typography)`
  max-width: 177px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 2px;
  overflow: hidden;
  padding-bottom: 1px;
  line-height: 1.2;
  text-align: center;
  height: auto;
  margin-bottom: 2px;
  word-break: break-all;
`;
